export default __webpack_public_path__ + "media/images/no-notifications-9ac58ae0.jpg";